import { Component, inject, OnInit } from '@angular/core';
import { SessionService } from '../../services/session-service';
import { HlmFieldImports } from '@spartan-ng/helm/field';
import { HlmCheckboxImports } from '@spartan-ng/helm/checkbox';
import { HlmAttachmentImports } from '@spartan-ng/helm/attachment';
import { HlmInputImports } from '@spartan-ng/helm/input';

@Component({
  selector: 'app-membership-form-data',
  imports: [HlmFieldImports,HlmCheckboxImports,HlmAttachmentImports,HlmInputImports],
  templateUrl: './membership-form-data.html',
  styleUrl: './membership-form-data.css',
})
export class MembershipFormData {

  public sessionService = inject(SessionService);

  ngOnInit(){
    console.log(this.sessionService.formSubData())
  }

}
